import {useLiveQuery} from 'dexie-react-hooks';
import {useSyncExternalStore} from 'react';
import {readSnapshot} from 'src/offline/offlineQuery';
import {getActiveSession} from 'src/offline/offlineSessionManager';
import {
  isFormsCacheRefreshing,
  subscribeFormsCache,
} from './formsOfflineSession';
import {formDefinitionsListKey, FORMS_CONTEXT_KEY} from './snapshotKeys';

export interface FormsCacheStatus {
  cachedAt?: Date;
  isRefreshing: boolean;
}

/** Live freshness of the owned forms definitions cache plus its refresh state. */
export const useFormsCacheStatus = (): FormsCacheStatus => {
  const cachedAt = useLiveQuery(async () => {
    const session = await getActiveSession(FORMS_CONTEXT_KEY);
    if (!session) return undefined;
    const snapshot = await readSnapshot(session.id, formDefinitionsListKey);
    return snapshot ? new Date(snapshot.cachedAt) : undefined;
  }, []);

  const isRefreshing = useSyncExternalStore(
    subscribeFormsCache,
    isFormsCacheRefreshing
  );

  return {cachedAt, isRefreshing};
};
